import { cn } from "@getgreenline/blaze-ui";
import { Check } from "lucide-react";

const steps = [
  { number: 1, title: "Brand", description: "Select your brand" },
  {
    number: 2,
    title: "Products",
    description: "Select from catalog",
  },
  { number: 3, title: "Ad format", description: "Choose & name" },
  {
    number: 4,
    title: "Markets & merchants",
    description: "States, regions & stores",
  },
  { number: 5, title: "Placement", description: "Where on the menu" },
  { number: 6, title: "Budget", description: "Spend & schedule" },
  { number: 7, title: "Review & launch", description: "Confirm & go live" },
];

type ProgressSidebarProps = {
  selectedStep: number;
  onStepSelect: (step: number) => void;
};

export function ProgressSidebar({
  selectedStep,
  onStepSelect,
}: ProgressSidebarProps) {
  return (
    <aside className="tw:sticky tw:top-17 tw:h-[calc(100vh-68px)] tw:w-68 tw:shrink-0 tw:self-start tw:border-r tw:bg-muted/20">
      <div className="tw:px-4 tw:py-6">
        <nav
          className="tw:flex tw:flex-col tw:gap-2"
          aria-label="Campaign progress"
        >
          {steps.map((step) => {
            const isSelected = step.number === selectedStep;
            const isCompleted = step.number < selectedStep;

            return (
              <button
                key={step.number}
                type="button"
                onClick={() => {
                  if (isCompleted) {
                    onStepSelect(step.number);
                  }
                }}
                className={cn(
                  "tw:flex tw:w-full tw:items-start tw:justify-start tw:gap-3 tw:rounded-xl tw:px-3 tw:py-3 tw:text-left",
                  isCompleted && "tw:cursor-pointer hover:tw:bg-background",
                  (isSelected || isCompleted) && "tw:bg-background",
                  !isCompleted && !isSelected && "tw:cursor-default",
                )}
                aria-disabled={!isCompleted && !isSelected}
              >
                <span
                  className={cn(
                    "tw:mt-0.5 tw:flex tw:h-7 tw:w-7 tw:shrink-0 tw:items-center tw:justify-center tw:rounded-full tw:border tw:text-sm tw:font-semibold",
                    isCompleted
                      ? "tw:border-sky-200 tw:bg-sky-100 tw:text-sky-700"
                      : isSelected
                        ? "tw:border-sky-500 tw:bg-sky-500 tw:text-white"
                        : "tw:border-border tw:bg-background tw:text-muted-foreground/70",
                  )}
                >
                  {isCompleted ? (
                    <Check className="tw:h-4 tw:w-4" />
                  ) : (
                    step.number
                  )}
                </span>
                <span className="tw:flex tw:flex-col tw:text-left">
                  <span
                    className={cn(
                      "tw:text-sm tw:font-medium",
                      isSelected || isCompleted
                        ? "tw:text-foreground"
                        : "tw:text-muted-foreground/70",
                    )}
                  >
                    {step.title}
                  </span>
                  <span
                    className={cn(
                      "tw:text-xs",
                      isSelected
                        ? "tw:text-muted-foreground"
                        : "tw:text-muted-foreground/60",
                    )}
                  >
                    {step.description}
                  </span>
                </span>
              </button>
            );
          })}
        </nav>
      </div>
    </aside>
  );
}
